export const en = {
  'shell.nav.people': 'People report',
  'people.title': 'People report',
  'people.description': 'Headcount, joiners and leavers, turnover, leave and sickness, lateness, no-shows and overtime, by branch, department and role.',
  'people.report.build': 'Build a people report',
  'people.report.title': 'People',
  'people.report.note': '{period}. Lateness and no-shows count rostered shifts of people who use the staff clock; overtime is clocked time beyond the rostered hours.',
  'reports.dataset.people': 'People',
  'reports.grouping.department': 'Department',
  'reports.grouping.role': 'Role',
  'reports.grouping.leaveType': 'Leave type',
  'reports.measure.people': 'People',
  'reports.measure.headcount': 'Headcount',
  'reports.measure.joiners': 'Joiners',
  'reports.measure.leavers': 'Leavers',
  'reports.measure.turnover': 'Turnover',
  'reports.measure.leaveDays': 'Leave days',
  'reports.measure.sickRate': 'Sick-leave rate',
  'reports.measure.late': 'Late arrivals',
  'reports.measure.noShows': 'No-shows',
  'reports.measure.overtime': 'Overtime hours',
  'reports.everyBranch': 'Every branch',
  'reports.noDepartment': 'No department',
  'reports.noLogin': 'No login',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.people': 'პერსონალის ანგარიში',
  'people.title': 'პერსონალის ანგარიში',
  'people.description': 'თანამშრომელთა რაოდენობა, მიღებულები და წასულები, დენადობა, შვებულება და ავადმყოფობა, დაგვიანებები, გამოუცხადებლობა და ზეგანაკვეთური — ფილიალების, დეპარტამენტებისა და როლების მიხედვით.',
  'people.report.build': 'პერსონალის ანგარიშის აწყობა',
  'people.report.title': 'პერსონალი',
  'people.report.note': '{period}. დაგვიანებები და გამოუცხადებლობა ითვლება იმ თანამშრომლების ცვლებზე, ვინც სააღრიცხვო ბარათს იყენებს; ზეგანაკვეთური არის დაგეგმილ საათებზე მეტად აღრიცხული დრო.',
  'reports.dataset.people': 'პერსონალი',
  'reports.grouping.department': 'დეპარტამენტი',
  'reports.grouping.role': 'როლი',
  'reports.grouping.leaveType': 'შვებულების ტიპი',
  'reports.measure.people': 'ადამიანები',
  'reports.measure.headcount': 'თანამშრომელთა რაოდენობა',
  'reports.measure.joiners': 'მიღებულები',
  'reports.measure.leavers': 'წასულები',
  'reports.measure.turnover': 'დენადობა',
  'reports.measure.leaveDays': 'შვებულების დღეები',
  'reports.measure.sickRate': 'ავადმყოფობის მაჩვენებელი',
  'reports.measure.late': 'დაგვიანებები',
  'reports.measure.noShows': 'გამოუცხადებლობა',
  'reports.measure.overtime': 'ზეგანაკვეთური საათები',
  'reports.everyBranch': 'ყველა ფილიალი',
  'reports.noDepartment': 'დეპარტამენტის გარეშე',
  'reports.noLogin': 'ანგარიშის გარეშე',
};
